module.exports = __webpack_public_path__ + "static/media/logoHoraSol.f3490e8a.png";